import { render, staticRenderFns } from "./ManageBrandingPage.vue?vue&type=template&id=0ee15137"
import script from "./ManageBrandingPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ManageBrandingPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports